import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampMealsIcon: React.FC<SVGComponentProps> = ({
  width = 24,
  height = 21
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0209 11.6596L6.29787 17.3411C6.14581 17.4932 5.95573 17.5727 5.72764 17.5796C5.49955 17.5865 5.30256 17.507 5.13668 17.3411C4.98462 17.1891 4.90859 16.9955 4.90859 16.7605C4.90859 16.5255 4.98462 16.332 5.13668 16.1799L13.0577 8.25895C12.8088 7.67836 12.7743 7.02173 12.954 6.28907C13.1337 5.55642 13.5277 4.89979 14.1359 4.3192C14.8686 3.58654 15.6842 3.158 16.5827 3.03359C17.4812 2.90918 18.2139 3.13036 18.7807 3.69713C19.3474 4.2639 19.5686 4.99656 19.4442 5.8951C19.3198 6.79364 18.8913 7.60924 18.1586 8.34189C17.578 8.95014 16.9214 9.34411 16.1887 9.52382C15.4561 9.70353 14.7994 9.66897 14.2189 9.42014L13.1821 10.4569L18.9051 16.1799C19.0572 16.332 19.1366 16.5221 19.1435 16.7502C19.1505 16.9783 19.071 17.1752 18.9051 17.3411C18.753 17.4932 18.5595 17.5692 18.3245 17.5692C18.0895 17.5692 17.896 17.4932 17.7439 17.3411L12.0209 11.6596ZM8.16407 10.8302L5.6758 8.34189C5.09521 7.7613 4.72888 7.02864 4.57682 6.14392C4.42476 5.25921 4.59756 4.47126 5.09521 3.78007C5.24727 3.57272 5.45117 3.45521 5.70691 3.42757C5.96265 3.39992 6.18037 3.48286 6.36008 3.67639L10.8182 8.17601L8.16407 10.8302Z"
        fill="#7F1D1D"
      />
    </svg>
  </SVGUniqueID>
);

export { BootcampMealsIcon };
